import axiosInstance from './axiosInstance';

const API_URL = 'https://idealonline.com.tr/service/idealonline/v1/';

export const getUserFolders = async (page, size, token) => {
  try {
    const response = await axiosInstance.post(
      `userpanel/userworkfoldersSearch?page=0&size=100`,
      { searchkeyword: "" },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response;
  } catch (err) {
    console.log("Klasörler yüklenemedi.", err);
  }
};

export const foldersFilterSearchElastic = async (folderId, selectedFilters, page, newpagesize, token, ordertype, orderfield) => {
  try {
    const filtersToSend = { ...selectedFilters };
    if (filtersToSend.endyear == "") {
      delete filtersToSend.endyear;
    }
    if (filtersToSend.startyear == "") {
      delete filtersToSend.startyear;
    }
    // console.log("Token being sent to folder search:", token);
    const response = await axiosInstance.post(
      `userpanel/userworkfolderspublicationsFilterSearchElastic/${folderId}`,
      filtersToSend,
      {
        params: {
          page: page,
          newpagesize: newpagesize,
          ordertype: ordertype,
          orderfield: orderfield
        },
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching folder search results:", error);
    // throw error;
  }
};

export const updateFolderPublicationStatus = async (folderId, publicationId, status, token) => {
  try {
    const response = await axiosInstance.get(
      `userpanel/userworkfolderspublicationsUpdateStatus/${folderId}/${publicationId}/${status}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating folder publication status:", error);
    throw error;
  }
};


export const deleteFolder = async (folderId, token) => {
  try {
    const response = await axiosInstance.get(
      `userpanel/userworkfolderUpdateStatus/${folderId}/-1`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error delete folder:", error);
    throw error;
  }
};

export const createFolder = async (folderName, token) => {
  try {
    const response = await axiosInstance.post(
      `userpanel/userworkfolderCreate`,
      { foldername: folderName, description: "" },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error create folder:", error);

  }
};

export const addPublicationsToFolder = async (payload, token) => {
  try {
    const response = await axiosInstance.post(
      `userpanel/userworkfolderspublicationsCreateList`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error create folder:", error);

  }
};

export const changeFolderName = async (folderId, foldername, description, token) => {
  try {
    const response = await axiosInstance.post(
      `userpanel/userworkfolderUpdate/${folderId}`,
      { foldername, description }, // Pass foldername and description directly
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error("Error changing folder name:", error);
    throw error;
  }
};

export const deleteFavoritePublication = async (id, token) => {
  try {
    const response = await axiosInstance.get(`userpanel/favoritepublicationsUpdateStatus/${id}/-1`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Favori silme işlemi sırasında hata:", error);
    throw error;
  }
};

// Get user and authors by current user id (GET, no request body, Authorization required)
export const userAndAuthorsListByUserId = async (token) => {
  try {
    const response = await axiosInstance.get(
      `userpanel/userandauthorsListByUserId`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching user and authors list:", error);
    throw error;
  }
};

export const userAndPublishersListByUserId = async (token) => {
  try {
    const response = await axiosInstance.get(
      `userpanel/userandpublishersListByUserId`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching user and publishers list:", error);
    throw error;
  }
};
export const ListByPublisherid = async (publisherid, page, size, token, data = []) => {
  try {
    const response = await axiosInstance.post(`userpanel/authorsListByPublisherid/${publisherid}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching authors list:", error);
    throw error;
  }
};

export const ListByAuthorid = async (authorid, page, size, token, data = []) => {
  try {
    const response = await axiosInstance.post(`userpanel/publishersListByAuthorid/${authorid}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching authors list:", error);
    throw error;
  }
};






export const userAndPublishersCreate = async (formData, token) => {
  try {
    const response = await axiosInstance.post(
      `userpanel/userandpublishersCreate`,
      formData,
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating user and publisher:", error);
    throw error;
  }
};
